export default __webpack_public_path__ + "static/media/pies.5af9d199.png";